import {Component} from 'react';
import './index.less';
import { BrowserRouter as Router, Route, Link} from 'react-router-dom'
import $ from 'jquery';
import { products } from '../../component/products';
import jQuery from 'jquery-easing';
import {withRouter} from 'react-router-dom'
import { changeUrlMobile, hideMenuMobile } from '../../common/changeUrl';
import { hideMask } from '../../component/cartMobile';


const toggleCover = (name) => {
  jQuery(`#${name.short}`).animate({
    opacity: 0
  },100,"easeInCubic",function(){
    $(`#${name.short}`).attr('src',name.details[2])
    jQuery(`#${name.short}`).animate({
      opacity: 1
    },200)
  })
}

const toggleCover2= (name) => {
  jQuery(`#${name.short}`).animate({
    opacity: 0.5
  },100,"easeInCubic",function(){
    $(`#${name.short}`).attr('src',name.specCover)
    jQuery(`#${name.short}`).animate({
      opacity: 1
    },100)
  })
}

const viewMenu = () => {
 if($(`.product-item-chevron, .product-list`).hasClass('active')){
  $(".collection-menu-mask").fadeOut(500)
  $(`.product-item-chevron, .product-list`).toggleClass('active')
 } else if(!$(`.product-item-chevron, .product-list`).hasClass('active')){
  $(".collection-menu-mask").fadeIn(500)
  $(`.product-item-chevron, .product-list`).toggleClass('active')
 }
}

class Collections extends Component {
  
  componentWillMount() {

    jQuery(".slideMask").animate({
      left: '-100vw'
    },1200,"easeInCubic",function(){
      $(".slideMask").css("left","100vw")
    })

    setTimeout(() => {
      window.scrollTo(0,0)
    }, 900);
  }
  
  componentDidMount(){
    if(!$(".collection").hasClass('active')){
      $(".collection").addClass('active')
    }
    $(".exclusive").removeClass('active')
    $(".discover").removeClass('active')

    jQuery(".AppMobile .collection-menu").delay(1500).animate({
      opacity: 1
    },1000,"easeInCubic")

    window.history.scrollRestoration = 'manual'
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    hideMask()
  }
  
  render () {
    return (
      <div className="container collection">
        <div className='collection-menu'>
          <div className='product-item-wrapper all' onClick={() => viewMenu()}><a className='product-item ' href='javascript:void(0)'>ALL PRODUCTS</a><div className='product-item-chevron'></div></div>
          <div className='product-list'>
            <div className='product-item-wrapper'><Link to={'/' + products.EN.b.url} onClick={() => changeUrlMobile()} className="product-item b">{products.EN.b.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.EN.f.url} onClick={() => changeUrlMobile()} className="product-item f">{products.EN.f.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.EN.g.url} onClick={() => changeUrlMobile()} className="product-item a">{products.EN.g.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.EN.c.url} onClick={() => changeUrlMobile()} className="product-item c">{products.EN.c.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.EN.e.url} onClick={() => changeUrlMobile()} className="product-item e">{products.EN.e.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.EN.k.url} onClick={() => changeUrlMobile()} className="product-item d">{products.EN.k.specName}</Link></div>
            {/* <div className='product-item-wrapper'><Link to={'/' + products.EN.l.url} onClick={() => changeUrlMobile()} className="product-item i">{products.EN.l.specName}</Link></div> */}
            <div className='product-item-wrapper'><Link to={'/' + products.EN.d.url} onClick={() => changeUrlMobile()} className="product-item d">{products.EN.d.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.EN.m.url} onClick={() => changeUrlMobile()} className="product-item d">{products.EN.m.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.EN.i.url} onClick={() => changeUrlMobile()} className="product-item i">{products.EN.i.specName}</Link></div>
          </div>
        </div>
        <div className='collection-menu-mask' onClick={() => viewMenu()}></div>
        <div className='collection-item'>
          <div className='section one'>
            
          <Link to={'/' + products.EN.e.url} onClick={() => changeUrlMobile()} className="items">
                <div className='item-cover'>
                  <img src={products.EN.e.specCover} alt={products.EN.e.specName} id={products.EN.e.short} style={{"object-position":" 50% 100%"}}></img>
                </div>
                <div className='item-info'>
                  <div className='item-info-name'>{products.EN.e.specName}</div>
                  <div className='item-info-spec'> 
                    <div className='item-info-volumn'>{products.EN.e.specIntro}</div>
                    
                    </div>
                </div>
              </Link>
              <Link to={'/' + products.EN.c.url} onClick={() => changeUrlMobile()} className="items">
                  <div className='item-cover'>
                    <img src={products.EN.c.specCover} alt={products.EN.c.specName} id={products.EN.c.short}></img>
                  </div>
                  <div className='item-info'>
                    <div className='item-info-name'>{products.EN.c.specName}</div>
                    <div className='item-info-spec'> 
                      <div className='item-info-volumn'>{products.EN.c.specIntro}</div>
                      
                      </div>
                  </div>
                </Link>
              <Link to={'/' + products.EN.d.url} onClick={() => changeUrlMobile()} className="items">
                <div className='item-cover' >
                  <img src={products.EN.d.specCover} alt={products.EN.d.specName} id={products.EN.d.short} style={{"object-position":" 50% 100%"}}></img>
                </div>
                <div className='item-info'>
                  <div className='item-info-name'>{products.EN.d.specName}</div>
                  <div className='item-info-spec'> 
                    <div className='item-info-volumn'>{products.EN.d.specIntro}</div>
                    
                    </div>
                </div>
              </Link>
            <Link to={'/' + products.EN.g.url} onClick={() => changeUrlMobile()} className="items">
              <div className='item-cover'>
                <img src={products.EN.g.specCover} alt={products.EN.g.specName} id={products.EN.g.short}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.EN.g.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.EN.g.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
          </div>
          <div className='section two'>
            <div className='left'>
            </div>
            <Link to={'/' + products.EN.b.url} onClick={() => changeUrlMobile()} className="items">
              <div className='item-cover'>
                <img src={products.EN.b.specCover} alt={products.EN.b.specName} id={products.EN.b.short}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.EN.b.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.EN.b.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
            
            <Link to={'/' + products.EN.k.url} onClick={() => changeUrlMobile()} className="items">
              <div className='item-cover' >
                <img src={products.EN.k.specCover} alt={products.EN.k.specName} id={products.EN.k.short} style={{"object-position":" 50% 50%"}}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.EN.k.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.EN.k.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
            <div className='right'>
            <Link to={'/' + products.EN.f.url} onClick={() => changeUrlMobile()} className="items">
              <div className='item-cover' >
                <img src={products.EN.f.specCover} alt={products.EN.f.specName} id={products.EN.f.short} style={{"object-position":" 50% 100%"}}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.EN.f.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.EN.f.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
            </div>
            <Link to={'/' + products.EN.l.url} onClick={() => changeUrlMobile()} className="items">
              <div className='item-cover' >
                <img src={products.EN.l.specCover} alt={products.EN.l.specName} id={products.EN.l.short} style={{"object-position":" 50% 0%"}}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.EN.l.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.EN.l.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
          </div>
          <div className='section one'>
              <Link to={'/' + products.EN.m.url} onClick={() => changeUrlMobile()} className="items">
              <div className='item-cover'>
                <img src={products.EN.m.specCover} alt={products.EN.m.specName} id={products.EN.m.short} onMouseEnter={() => toggleCover(products.EN.m)} onMouseLeave={() => toggleCover2(products.EN.m)}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.EN.m.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.EN.m.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
            <Link to={'/' + products.EN.i.url} onClick={() => changeUrlMobile()} className="items">
              <div className='item-cover'>
                <img src={products.EN.i.specCover} alt={products.EN.i.specName} id={products.EN.i.short} onMouseEnter={() => toggleCover(products.EN.i)} onMouseLeave={() => toggleCover2(products.EN.i)}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.EN.i.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.EN.i.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Collections);
